var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIrProj(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.825,
    height: 31.825,
    viewBox: "0 0 31.825 31.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-left",
    transform: "translate(14.321 41.368) rotate(-135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6998",
    "data-name": "Caminho 6998",
    d: "M6.75,16.875A1.125,1.125,0,0,1,7.875,18V28.125H18a1.125,1.125,0,0,1,0,2.25H6.75A1.125,1.125,0,0,1,5.625,29.25V18A1.125,1.125,0,0,1,6.75,16.875Z",
    fill: "#1abfd5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6999",
    "data-name": "Caminho 6999",
    d: "M27.8,8.2a1.125,1.125,0,0,1,0,1.593L7.546,30.047a1.126,1.126,0,0,1-1.593-1.593L26.2,8.2a1.125,1.125,0,0,1,1.593,0Z",
    fill: "#1abfd5",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIrProj);
export default __webpack_public_path__ + "static/media/arrow_ir_proj.898f3bbc4a60c33241a813818fa93855.svg";
export { ForwardRef as ReactComponent };